<template>
  <div>
  </div>
</template>

<style>
.senha-invalida {
  display: none;
  color: red;
  font-weight: bold;
  font-size: 1.4rem;
}
</style>


<script>
  import Swal from 'sweetalert2'
  import Autenticacao from '@/services/Autenticacao'
  let route = null
  const mostraErro = (erro) => {
    if (erro === 'erro-campo-vazio') {
      document.getElementById('erro-campo-vazio').style.display = 'block';
      document.getElementById('erro-tamanho').style.display = 'none';
      document.getElementById('erro-nao-confere').style.display = 'none';
    } else if (erro === 'erro-tamanho') {
      document.getElementById('erro-campo-vazio').style.display = 'none';
      document.getElementById('erro-tamanho').style.display = 'block';
      document.getElementById('erro-nao-confere').style.display = 'none';
    } else {
      document.getElementById('erro-campo-vazio').style.display = 'none';
      document.getElementById('erro-tamanho').style.display = 'none';
      document.getElementById('erro-nao-confere').style.display = 'block';
    }
  }

  const limparErros = () => {
    document.getElementById('erro-campo-vazio').style.display = 'none';
    document.getElementById('erro-tamanho').style.display = 'none';
    document.getElementById('erro-nao-confere').style.display = 'none';
  }

  const alterarSenha = (codigo, email) => {
    return Swal({
      title: 'Redefinição de senha',
      html: `<input id="senha" type="password" class="swal2-input senha" placeholder="Inserir sua nova senha"/>
             <input id="confirmaSenha" type="password" class="swal2-input senha" placeholder="Confirmar sua nova senha"/>
             <p id="erro-campo-vazio" class="senha-invalida">Campos vazios não são permitidos!</p>
             <p id="erro-tamanho" class="senha-invalida">Senha deve ter mais de 8 letras/numeros!</p>
             <p id="erro-nao-confere" class="senha-invalida">As senhas não conferem!</p>`,
      focusConfirm: true,
      showCancelButton: true,
      confirmButtonText: 'Alterar',
      reverseButtons: true,
      allowOutsideClick: false,
      preConfirm: () => {
        const elSenha = document.getElementById('senha')
        const elConfirmaSenha = document.getElementById('confirmaSenha')
        elSenha.removeEventListener('input', limparErros)
        elSenha.addEventListener('input', limparErros)
        elConfirmaSenha.removeEventListener('input', limparErros)
        elConfirmaSenha.addEventListener('input', limparErros)
        const senha = elSenha.value
        const confirmaSenha = elConfirmaSenha.value
        if (!senha || !confirmaSenha) {
          mostraErro('erro-campo-vazio')
          return Promise.reject(false)
        } else if (senha.length < 8 || confirmaSenha.length < 8) {
          mostraErro('erro-tamanho')
          return Promise.reject(false)
        } else if (senha !== confirmaSenha) {
          mostraErro('erro-nao-confere')
          return Promise.reject(false)
        } else {
          return Autenticacao.confirmarRedefinicaoSenha(codigo, email, senha)
        }
      }
    })
    .then(response => {
      Swal(
        'Alteração de senha!',
        `Sua senha foi alterada com sucesso!`,
        'success'
      ).then(() => {
        route && route.push({
          name: 'entrar'
        })
      })
    })
    .catch(error => {
      route && route.push({
        name: 'entrar'
      })
    })
  }

  export default {
    name: 'ResetPasswordCtrl',
    created () {
      const query = this.$route.query
      if (query.mode && query.mode === 'resetPassword' && query.oobCode) {
        Autenticacao.validarRedefinicaoSenha(query.oobCode)
          .then(email => {
            route = this.$router
            alterarSenha(query.oobCode, email)
          })
          .catch(() => {
            Swal(
              'Erro na validação da sua conta!',
              `Aparentemente o código expirou, peça uma nova senha ou favor entrar em contato com o suporte!`,
              'error'
            )
            .then(() => {
              this.$router.push({
                name: 'entrar'
              })
            })
          })
      } else {
        this.$router.push({
          name: 'entrar'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GeneralViews/ResetPassword.vue